import * as React from 'react';
import { styled } from './druid/./druid/Utilities';
import { TextFieldBase } from '/druid/TextField.base';
import { ITextFieldProps, ITextFieldStyles, ITextFieldStyleProps } from '/druid/TextField.types';
import { getStyles } from '/druid/TextField.styles';
export { ITextField } from '/druid/TextField.types';

export const TextField: React.FunctionComponent<ITextFieldProps> = styled<
  ITextFieldProps,
  ITextFieldStyleProps,
  ITextFieldStyles
>(TextFieldBase, getStyles, undefined, {
  scope: 'TextField',
});
